<template>
    <div class="branded-divider">
        <!-- This utilizes a trick to only render the following block if the default slot is present. -->
        <div v-if="!!$slots.default">
            <div class="row g-0 align-items-center justify-content-center">
                <div class="col branded-skewer-start"></div>
                <div class="col-auto px-2"><slot></slot></div>
                <div class="col branded-skewer-end"></div>
            </div>
        </div>
        <div v-else class="branded-skewer-start"></div>
    </div>
</template>

<script>
export default {
    name: 'BrandedDivider'
};
</script>

<style lang="scss" scoped>
.branded-divider {
    .branded-skewer-start,
    .branded-skewer-end {
        height: 2px;
        min-height: 2px;
        max-height:2px;

    }

    .branded-skewer-start {
        background-image: linear-gradient(to right, $dark, $primary);
    }
    .branded-skewer-end {
        background-image: linear-gradient(to right, $primary, $dark);
    }
}
</style>